























































import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";

import Step1 from "@/components/ClassesAddSteps/Step1.vue";
import Step2 from "@/components/ClassesAddSteps/Step2.vue";
import Step3 from "@/components/ClassesAddSteps/Step3.vue";
import Step4 from "@/components/ClassesAddSteps/Step4.vue";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";

import { IStudent } from "@/models/interfaces/students";
import { IVuexState } from "@/models/interfaces/store";
import { ISchool } from "@/models/interfaces/schools";
import { IClassPayload } from "@/models/interfaces/classes";
import { ITeacher } from "@/models/interfaces/teachers";

import { Action, State } from "vuex-class";

import RequestState from "@/utils/mixins/RequestState";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    Step1,
    Step2,
    Step3,
    Step4,

    BaseAlert,
    BaseButton,
    BasePopup,
    BaseSpinner
  }
})
export default class ClassStepperForm extends Mixins(RequestState) {
  @Prop({ required: true, type: Boolean })
  private loading!: boolean;

  @Prop({ type: Object, default: () => ({}) })
  private initialData!: {
    teachers: string[];
    students: string[];
    className: string;
  };

  @Action("students/fetchStudents")
  private fetchStudents!: () => Promise<{ students: IStudent[] }>;

  @Action("teachers/fetchTeachers")
  private fetchTeachers!: () => Promise<ITeacher[]>;

  @State("teachers", { namespace: "teachers" })
  private teachers!: IVuexState<ITeacher>;

  @State("students", { namespace: "students" })
  private students!: IVuexState<IStudent[]>;

  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @Action("schools/fetchSchools")
  private fetchSchools!: () => Promise<{ schools: ISchool[] }>;

  private currentStepIndex = 0;
  private createClassPayload: {
    schoolId: string;
    data: IClassPayload;
  } | null = null;

  private showPopup = false;
  private popupMessage = "";
  private popupAction = "";

  private selectedStudents: string[] = [];
  private selectedTeachers: string[] = [];

  private get showContent() {
    return (
      this.hasSucceeded(this.schools) &&
      this.hasSucceeded(this.students) &&
      this.hasSucceeded(this.teachers)
    );
  }

  private get pending() {
    return (
      this.isPending(this.schools) ||
      this.isPending(this.students) ||
      this.isPending(this.teachers)
    );
  }

  private get getFormData() {
    return {
      className: this.createClassPayload?.data.className,
      students: `${this.selectedStudents.length} students`,
      teachers: `${this.selectedTeachers.length} teachers`
    };
  }

  private get failed() {
    return (
      this.hasFailed(this.schools) ||
      this.hasFailed(this.students) ||
      this.hasFailed(this.teachers)
    );
  }

  private get schoolsOptions() {
    return this.schools.data?.map(({ schoolName, schoolId }) => ({
      label: schoolName,
      value: schoolId
    }));
  }

  private next() {
    this.currentStepIndex++;
  }

  private onPrev() {
    if (this.currentStepIndex === 0) {
      this.$router.push("/classes");
    } else {
      this.currentStepIndex--;
    }
  }

  private async submit() {
    this.showPopup = false;

    this.$emit("submit", {
      class: this.createClassPayload,
      teachers: this.selectedTeachers,
      students: this.selectedStudents
    });
  }

  private onPopupSubmit() {
    if (!this.popupAction) {
      this.showPopup = false;
      return;
    }

    switch (this.popupAction) {
      case "submit":
        amplitude
          .getInstance()
          .logEvent(
            `${eventCodeByName(
              EventsNames.UserClicksOkOnPopupAfterClassCreate
            )} ${EventsNames.UserClicksOkOnPopupAfterClassCreate}`
          );
        this.submit();
        break;

      default:
        break;
    }
  }

  private step1Next(payload: { schoolId: string; data: IClassPayload }) {
    this.createClassPayload = payload;
    this.next();
  }

  private step2Next(selectedStudents: string[]) {
    this.selectedStudents = selectedStudents;
    this.next();
  }

  private step3Next(selectedTeachers: string[]) {
    this.selectedTeachers = selectedTeachers;
    this.next();
  }

  private step4Next() {
    this.popupMessage = this.$t("tables.classes.errors.canBeAssign") as string;
    this.popupAction = "submit";
    this.showPopup = true;
  }

  public mounted() {
    this.fetchSchools();
    this.fetchStudents();
    this.fetchTeachers();
  }

  @Watch("currentStepIndex")
  private onIndexChange(val: number) {
    this.$emit("on-index-change", val);
  }
}
